module.exports = __webpack_public_path__ + "static/img/strona_035.af938ed4.jpg";